import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading) {
      auth.signinRedirect();
    }
  }, [auth]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      Redirecting to login...
    </div>
  );
}

export default App;
